import React from 'react';
import { getInitials } from '../helpers/myProfileConfig';

export const MyProfileInfoCard = ({
    name,
    email,
    role,
    active,
    avatarUrl,
    isSavingAvatar,
    avatarInputRef,
    onAvatarSelected,
    isAvailable,
    onAvailabilityChange,
    phone,
    onPhoneChange,
    onPhoneSave,
    isSavingPhone,
}) => {
    return (
        <div className="card card__no-border profile-card-surface">
            <div className="card-body p-4">
                <div className="d-flex align-items-start justify-content-between gap-3 mb-4">
                    <div className="d-flex align-items-center gap-3">
                        <input
                            ref={avatarInputRef}
                            type="file"
                            accept="image/*"
                            className="d-none"
                            onChange={onAvatarSelected}
                        />

                        <button
                            type="button"
                            className="profile-avatar-button"
                            onClick={() => avatarInputRef.current?.click()}
                            disabled={isSavingAvatar}
                            aria-label="Cambiar imagen de perfil"
                        >
                            {avatarUrl ? (
                                <img src={avatarUrl} alt="Avatar" className="profile-avatar-image" />
                            ) : (
                                <span className="profile-avatar-initials">{getInitials(name)}</span>
                            )}
                        </button>

                        <div>
                            <h6 className="fw-semibold mb-1">{name || '-'}</h6>
                            <div className="text-muted fs-12">Haz clic en el avatar para cambiar la imagen</div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <label className="form-label d-flex justify-content-between align-items-center">
                            <span>Disponibilidad</span>
                            <span className={`badge ${isAvailable ? 'bg-soft-success text-success' : 'bg-soft-warning text-warning'}`}>
                                {isAvailable ? 'Disponible' : 'No disponible'}
                            </span>
                        </label>
                        <div className="form-check form-switch mt-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked={Boolean(isAvailable)}
                                onChange={onAvailabilityChange}
                            />
                        </div>
                        <div className="mt-2">
                            <span className={`badge ${active ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger'}`}>
                                {active ? 'Activo' : 'Inactivo'}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row g-3">
                    <div className="col-12 col-md-6">
                        <label className="form-label">Correo electrónico</label>
                        <input className="form-control" value={email || ''} disabled />
                    </div>
                    <div className="col-12 col-md-6">
                        <label className="form-label">Función</label>
                        <input className="form-control" value={role || 'USER'} disabled />
                    </div>
                    <div className="col-12 col-md-6">
                        <label className="form-label">Teléfono</label>
                        <div className="d-flex gap-2">
                            <input
                                className="form-control"
                                value={phone}
                                onChange={(event) => onPhoneChange(event.target.value || '')}
                                placeholder="Opcional"
                            />
                            <button
                                type="button"
                                className="btn btn-light-brand"
                                onClick={onPhoneSave}
                                disabled={isSavingPhone}
                            >
                                {isSavingPhone ? 'Guardando...' : 'Guardar'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
